import { MenuItem, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";

import { faCheck, faFilter } from "@fortawesome/pro-regular-svg-icons";

import { Icon } from "@/components";

import { ToDoType } from "../../ToDoList/enum/ToDoType.enum";

export const SORT_BY_ALL = "SORT_BY_ALL";

interface SortDropDownProps {
	options: ToDoType[];
	className?: string;
	value: ToDoType | typeof SORT_BY_ALL;
	onChange: (event: React.ChangeEvent<{ value: unknown }>) => void;
}

export default function SortDropDown({ options, className, onChange, value }: SortDropDownProps) {
	const { t } = useTranslation();
	const ts = (key: string) => t(`manage-to-dos.${key}`);

	return (
		<TextField
			select
			InputProps={{
				startAdornment: <Icon className="w-5 h-5" icon={faFilter} />,
			}}
			SelectProps={{
				renderValue: (selected) => (
					<>{selected === SORT_BY_ALL ? ts("filter-by") : ts(`${selected}`)}</>
				),
				MenuProps: {
					PaperProps: {
						sx: {
							padding: "8px",
							width: "140px",
							marginTop: "4px",
							borderRadius: "12px",
							"& .MuiList-root": {
								margin: "0px",
								padding: "0px",
								gap: "8px",
								display: "flex",
								flexDirection: "column",
							},
							"& .MuiMenuItem-root": {
								display: "flex",
								alignItems: "center",
								justifyContent: "space-between",
								fontSize: "14px",
								margin: "0px",
								padding: "0px",
								backgroundColor: "transparent !important",
								"&.Mui-selected": {
									color: "#B8431A",
								},
								"&:hover": {
									backgroundColor: "transparent !important",
								},
							},
						},
					},
				},
			}}
			className={className}
			inputProps={{
				style: {
					display: "flex",
					alignItems: "center",
					fontSize: "14px",
				},
			}}
			sx={{
				"min-width": "160px",
				"& .MuiSelect-select": {
					alignSelf: "flex-end",
					padding: "8px",
					fontSize: "14px",
				},
				"& .MuiInputBase-root": {
					marginBottom: "0px",
					borderRadius: "12px",
					fontSize: "14px",
				},
				"& .MuiSelect-icon": {
					color: "#11110F",
				},
			}}
			value={value ?? ""}
			onChange={onChange}
		>
			<MenuItem key={-1} value={SORT_BY_ALL}>
				{ts(SORT_BY_ALL)}
				{value === SORT_BY_ALL && <Icon className="ml-2 w-5 h-5" icon={faCheck} />}
			</MenuItem>
			{options.map((status, index) => (
				<MenuItem key={index} value={status}>
					{ts(`${status}`)}
					{value === status && <Icon className="ml-2 w-5 h-5" icon={faCheck} />}
				</MenuItem>
			))}
		</TextField>
	);
}
